import {ReactNode, useState} from 'react'
import ItemsCarousel from 'react-items-carousel'
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
type Props = {
    children: ReactNode
}

const Slider: React.FC<Props> = ({children}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const chevronWidth = 20
  return (
    <div style={{padding: `0 ${chevronWidth}px`, maxWidth: '94%', margin: 'auto', marginTop: '25px'}}>
      <ItemsCarousel
        infiniteLoop={false}
        gutter={12}
        activePosition={'center'}
        chevronWidth={60}
        disableSwipe={false}
        numberOfCards={3}
        slidesToScroll={1}
        outsideChevron={true}
        activeItemIndex={activeItemIndex}
        requestToChangeActive={setActiveItemIndex}
        rightChevron={<ChevronRightOutlinedIcon sx={{color: '#1f8ce9'}} />}
        leftChevron={<ChevronLeftOutlinedIcon sx={{color: '#1f8ce9'}} />}
      >
        {children}
      </ItemsCarousel>
    </div>
  )
}

export {Slider}
